import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useGetStonesQuery } from '@app/store/slices/stones/stonesApi';
import { STONE_COLORS } from '@app/shared/constants/stones';
import { StoneMatrixItem, FrontendEnergyStone } from '@app/shared/types/pages/stones';

export const useGetEnergyStoneInfo = () => {
  const { t } = useTranslation();
  const {
    data: stonesResponse,
    isLoading: isStonesLoading,
    isError: isStonesError,
  } = useGetStonesQuery();
  const stones = stonesResponse?.data || [];

  const stoneMatrix = t('stone_matrix', { returnObjects: true }) as StoneMatrixItem[];

  const sortedStones: FrontendEnergyStone[] = useMemo(() => {
    return [...stones].map((stone, index) => {
      const matrixItem = stoneMatrix?.[index] ?? {};

      const sortedAbilities = matrixItem.abilities
        ? [...matrixItem.abilities].sort((a, b) => (a.matrixIndex ?? 0) - (b.matrixIndex ?? 0))
        : [];

      return {
        ...stone,
        ...(STONE_COLORS[index] ?? {}),
        ...matrixItem,
        abilities: sortedAbilities,
      };
    });
  }, [stones, stoneMatrix]);

  return {
    energyStones: sortedStones,
    isStonesLoading,
    isStonesError,
  };
};
